module.exports = __webpack_public_path__ + "img/color_redgold_a-2111-1@2x.7fe1397.webp";